import { useContext } from 'react';
import invariant from 'invariant';
import AuthContext from '../AuthProvider/AuthContext';
/**
 * Hook vraci `true` pokud je uzivatel prihlaseny.
 */

export default function useIsAuthenticated() {
  var ctx = useContext(AuthContext);
  invariant(ctx, "'useIsAuthenticated' can be called only inside 'AuthProvider'");
  return ctx.isAuthenticated;
}